export default __webpack_public_path__ + "static/media/ping.dfcc0128.wav";